import React, { useState, useEffect } from 'react';
import {config} from "../shared/config";
import * as util from '../shared/commons';
import axios from "axios";
import 'primeicons/primeicons.css';
import { Col, Container, Row } from 'react-bootstrap';
import { Link, Navigate, useNavigate  } from 'react-router-dom';
import { Button } from 'primereact/button';
import ShowError from '../shared/ShowError';
import Laoding from '../shared/Laoding';


export default function SelectIpg(props) {
    const navigate = useNavigate();
    const [redirectUrl, setRedirectUrl] = useState("");
    const [selectedIndex, setSelectedIndex] = useState(0);
    const [loadingIpgs, setLoadingIpgs] = useState(true);
    const [saving, setSaving] = useState(false);
    const [paymentByWalletDone, setPaymentByWalletDone] = useState(false);
    const [ipgs, setIpgs] = useState([]);
    const [walletAmount, setWalletAmount] = useState(0);
    const [errorVisible, setErorVisible] = useState(false);
    const [errorMessage, setErrorMessage] = useState("");
    const [taxServiceLink, setTaxServiceLink] = useState("");

    useEffect(() => {
        localStorage.removeItem("verify_result");
        setLoadingIpgs(true);
        var params = {
            login:util.getLoginDto(), 
        };
        var url = config.Server+`/payment/ipg-list-with-wallet/get`;
        console.log("url in select ipg is>", url)
        console.log("params in select ipg is>", params)
        axios
        .post(url, params )
        .then(response => {
            console.log("main response is>", response)
            var response = response.data;
            if(response.state === "ok"){
                response = response.data;
                console.log("resopnse is> ", response); 
                if(response.ipgs.length > 0){              
                    for(var i=0;i<response.ipgs.length;i++){
                        response.ipgs[i]["isChecked"] = false;
                    }
                    response.ipgs[0].isChecked = true;
                }
                else{
                    setSelectedIndex(-1);
                }
                setIpgs(response.ipgs);
                setWalletAmount(response.walletAmount);
                setLoadingIpgs(false);
            }
            else{
                setErrorMessage(response.message);
                setErorVisible(true);
                //setLoading(false);
                console.log("error is>", response.message)
            }
        })
        .catch(error => {
            console.log("error is>", error)
            setErrorMessage(error.code + "," + error.message);
            setErorVisible(true);
            //setLoading(false);
        });
    }, []);
    
    const onBackButtonClick = function(){
        var url = util.getBeforeIpgUrl();
        if(url == "BuyProductSummary"){
            navigate("/buy/product/summary");
        }
        else if(url == "ShowMyContract"){
            navigate("/my-contracts/list");
        }
        else if(url == "PromoteContractModule"){
            navigate("/contract/module/promote");
        }
        else if(url == "PromoteContractParameter"){
            navigate("/contract/paremeter/promote");
        }
        else{
            alert("not defiend")
        }
    }
    const onContinueButtonClick = function(){
        var url = config.Server;
        var ipgType = 0;
        if(selectedIndex == -1){
            if(walletAmount < parseInt(util.getIpgTransactionAmount())){
                setErrorMessage("موجودی کیف پول کافی نمی باشد");
                setErorVisible(true);
                return;
            }
            url += `/payment/wallet/payment/request`;
        }
        else{
            ipgType = ipgs[selectedIndex].ipgType.id;
            if(ipgs[selectedIndex].ipgType.id == util.IpgTypes.Zarinpal){
                url += `/payment/zarinpal/payment/request`;
            }
            else{
                alert("undefined ipg");
                return;
            }
        }
        console.log("ipg is>", ipgs[selectedIndex])
        console.log("util.getIpgTransactionType() is>", util.getIpgTransactionType())
        var params = {};
        if(util.getIpgTransactionType() == util.WallerTransactionTypes.BuyProduct){
            var buy = util.getBuy();
            var buyCompany = util.getBuyCompany();
            var buyParams = [];
            Object.keys(buy.parameters).forEach(key => {
                if (typeof buy.parameters[key] === "number") {
                    buyParams.push({name:key, value:buy.parameters[key].toString()})
                }
                else{
                    buyParams.push({name:key, value:buy.parameters[key]});
                }
            });
            params = {
                login:util.getLoginDto(), 
                ipgType:ipgType,
                type:util.getIpgTransactionType(),
                contractId:"",
                companyDetail:{isPersonal:buyCompany.isPersonal, personNationalId:buyCompany.personNationalId, economicCode:buyCompany.economicCode,companyNationalId:buyCompany.companyNationalId, title:buyCompany.title},
                productId:buy.productId,
                modules:buy.modules,
                parameters:buyParams,
                cityId:buyCompany.city.id,
                discountToken:buy.discountToken,
                reagentMobile:"",
                fixAmount:0,
                otherSystemIdentity:util.getOtherSystemDetail().otherSystemIdentity
            };
        }
        else if(util.getIpgTransactionType() == util.WallerTransactionTypes.BuyService){
            var buy = util.getBuy();
            var buyParams = [];
            Object.keys(buy.parameters).forEach(key => {
                if (typeof buy.parameters[key] === "number") {
                    buyParams.push({name:key, value:buy.parameters[key].toString()})
                }
                else{
                    buyParams.push({name:key, value:buy.parameters[key]});
                }
            });
            params = {
                login:util.getLoginDto(), 
                ipgType:ipgType,
                type:util.getIpgTransactionType(),
                contractId:"",
                companyDetail:null,
                productId:buy.productId,
                modules:buy.modules,
                parameters:buyParams,
                cityId:"",
                discountToken:buy.discountToken,
                reagentMobile:"",
                fixAmount:0,
                otherSystemIdentity:util.getOtherSystemDetail().otherSystemIdentity
            };
        }
        else if(util.getIpgTransactionType() == util.WallerTransactionTypes.RecontinueContract){
            var buy = util.getBuy();
            var buyParams = [];
            params = {
                login:util.getLoginDto(), 
                ipgType:ipgType,
                type:util.getIpgTransactionType(),
                contractId:buy.productId,
                companyDetail:{isPersonal:true, personNationalId:"", economicCode:"",companyNationalId:"", title:""},
                productId:"",
                modules:[],
                parameters:[],
                cityId:"",
                discountToken:"",
                reagentMobile:"",
                fixAmount:buy.price,
                otherSystemIdentity:util.getOtherSystemDetail().otherSystemIdentity
            };
        }
        else if(util.getIpgTransactionType() == util.WallerTransactionTypes.PromoteContractModule){
            var buy = util.getBuy();
            var buyParams = [];
            params = {
                login:util.getLoginDto(), 
                ipgType:ipgType,
                type:util.getIpgTransactionType(),
                contractId:buy.productId,
                companyDetail:{isPersonal:true, personNationalId:"", economicCode:"",companyNationalId:"", title:""},
                productId:"",
                modules:buy.modules,
                parameters:[],
                cityId:"",
                discountToken:"",
                reagentMobile:"",
                fixAmount:buy.price,
                otherSystemIdentity:util.getOtherSystemDetail().otherSystemIdentity
            };
        }
        else if(util.getIpgTransactionType() == util.WallerTransactionTypes.PromoteContractParameter){
            var buy = util.getBuy();
            var buyParams = [];
            Object.keys(buy.parameters).forEach(key => {
                if (typeof buy.parameters[key] === "number") {
                    buyParams.push({name:key, value:buy.parameters[key].toString()})
                }
                else{
                    buyParams.push({name:key, value:buy.parameters[key]});
                }
            });
            params = {
                login:util.getLoginDto(), 
                ipgType:ipgType,
                type:util.getIpgTransactionType(),
                contractId:buy.productId,
                companyDetail:{isPersonal:true, personNationalId:"", economicCode:"",companyNationalId:"", title:""},
                productId:"",
                modules:[],
                parameters:buyParams,
                cityId:"",
                discountToken:"",
                reagentMobile:"",
                fixAmount:buy.price,
                otherSystemIdentity:util.getOtherSystemDetail().otherSystemIdentity
            };
        }
        else{
            alert("undefined transaction type");
            return;
        }
        console.log("params in ipg is>", params);
        console.log("url in ipg is>", url);
        
        setSaving(true);
        axios
        .post(url, params )
        .then(res => {
            var response = res.data;
            if(response.state === "ok"){
                response = response.data;
                if(selectedIndex == -1){
                    setPaymentByWalletDone(true);
                    setErrorMessage(response);

                    var buy = util.getBuy();
                    var osd = util.getOtherSystemDetail();
                    console.log("buy is:", buy);
                    console.log("osd is:", osd);
                    if((osd != null)&&(buy.enName == "TaxService")){
                        if(osd.otherSystemIdentity!= ""){
                            var url =  config.HanaAccUrl + "/Client/CheckContract?taxMemory=" + osd.otherSystemIdentity;
                            setTaxServiceLink(url);
                        }
                    }
                    util.deleteBuy();
                    util.deleteBuyService();
                    util.deleteBuyCompany();
                    util.deleteOtherSystemDetail(); 
                }
                else{
                    console.log("payment url is>", response);
                    document.location = response;
                }
            }
            else{
                setErrorMessage(response.message);
                setErorVisible(true);
                setSaving(false);
            }
        })
        .catch(error => {
            console.log("error is>", error)
            setErrorMessage(error.code + "," + error.message);
            setErorVisible(true);
            setSaving(false);
        });
        
    }
    const onIpgSelected = function (index){
        var newIpgs = [...ipgs];
        for(var i=0;i<newIpgs.length;i++){
            newIpgs[i].isChecked = false;
        }
        if(index>=0){
            newIpgs[index].isChecked = true;
        }
        else{

        }
        setSelectedIndex(index);
        setIpgs(newIpgs);
        console.log("ipgs is>", ipgs);
    }
    return(
        (redirectUrl != "")?
        <>
            <Navigate to={redirectUrl} replace={false}  />
        </>
        :
        (loadingIpgs)?
        <>
            <Row>
                <Col className="d-flex justify-content-center align-items-center" style={{height:"calc(100vh - 70px)"}}>
                    <Laoding showLable={true} label="در حال دریافت لیست درگاه بانکی..." />
                </Col>
            </Row>
            <ShowError visible={errorVisible} message={errorMessage} closeError={()=>{setErorVisible(false)}} />
        </>
        :
        paymentByWalletDone?
        <>
            <Row>
                <Col className="d-flex justify-content-center align-items-center" style={{height:"calc(100vh - 70px)"}}>
                    <table style={{width:"100%", minWidth:"250px", marginLeft:"auto", marginRight:"auto"}}>
                        <tbody>
                            <tr>
                                <td style={{width:"100%", textAlign:"center"}}>
                                    <img src={require('../lib/images/hana.webp')} style={{width:"64px"}} />
                                    {/* <span style={{fontSize:"4em", textAlign:"center"}} className="pi pi-user"></span> */}
                                </td>
                            </tr>
                            <tr>
                                <td style={{fontSize:"1.5em", textAlign:"center"}}>{errorMessage}</td>
                            </tr>
                            <tr><td>&nbsp;</td></tr>
                            {
                                (util.getIpgTransactionType() == util.WallerTransactionTypes.BuyProduct)?
                            <tr>
                                <td style={{fontSize:"1em", textAlign:"center", direction:"ltr"}}>
                                    {
                                        taxServiceLink == ""?
                                        <Button severity="success" onClick={()=>{navigate('/my-contracts/list')}} style={{borderRadius:"5px"}}>&nbsp;&nbsp;مشاهده قراداد های من&nbsp;&nbsp;</Button>
                                        :
                                        <>
                                        جهت تکمیل فرایند بر رو لینک زیر کلیک نمائید
                                        <br/>
                                        <a 
                                            href={taxServiceLink} 
                                            style={{
                                            display: 'inline-block',
                                            padding: '10px 20px',
                                            backgroundColor: '#007bff',
                                            color: 'white',
                                            textDecoration: 'none',
                                            borderRadius: '5px'
                                            }}
                                        >
                                            فعالسازی مجوز در سامانه مودیان
                                        </a>
                                        </>
                                    }
                                    
                                </td>
                            </tr>
                            :
                                (util.getIpgTransactionType() == util.WallerTransactionTypes.BuyService)?
                            <tr>
                                <td style={{fontSize:"1em", textAlign:"center", direction:"ltr"}}>
                                    {
                                        <Button severity="success" onClick={()=>{navigate('/my-services/list')}} style={{borderRadius:"5px"}}>&nbsp;&nbsp;مشاهده خدمات من&nbsp;&nbsp;</Button>
                                    }
                                    
                                </td>
                            </tr>
                                :
                                (util.getIpgTransactionType() == util.WallerTransactionTypes.RecontinueContract)?
                            <tr>
                                <td style={{fontSize:"1em", textAlign:"center", direction:"ltr"}}>
                                    <Button severity="success" onClick={()=>{navigate('/my-contracts/list')}} style={{borderRadius:"5px"}}>&nbsp;&nbsp;مشاهده قراداد های من&nbsp;&nbsp;</Button>
                                    
                                </td>
                            </tr>
                                :(util.getIpgTransactionType() == util.WallerTransactionTypes.PromoteContractModule)?
                            <tr>
                                <td style={{fontSize:"1em", textAlign:"center", direction:"ltr"}}>
                                    <Button severity="success" onClick={()=>{navigate('/my-contracts/list')}} style={{borderRadius:"5px"}}>&nbsp;&nbsp;مشاهده قراداد های من&nbsp;&nbsp;</Button>
                                    
                                </td>
                            </tr>
                                :(util.getIpgTransactionType() == util.WallerTransactionTypes.PromoteContractParameter)?
                            <tr>
                                <td style={{fontSize:"1em", textAlign:"center", direction:"ltr"}}>
                                    <Button severity="success" onClick={()=>{navigate('/my-contracts/list')}} style={{borderRadius:"5px"}}>&nbsp;&nbsp;مشاهده قراداد های من&nbsp;&nbsp;</Button>
                                    
                                </td>
                            </tr>
                                :
                            <tr>
                                <td style={{fontSize:"1em", textAlign:"center", direction:"ltr"}}>
                                    نوع تراکنش مشخص نمی باشد
                                    
                                </td>
                            </tr>

                            }
                            <tr><td>&nbsp;</td></tr>

                        </tbody>
                    </table>
                </Col>
            </Row>
        </>
        :
        (ipgs.length == 0)?
        <>
            <Row>
                <Col className="d-flex justify-content-center align-items-center" style={{height:"calc(100vh - 70px)"}}>
                    درگاه پرداخت فعال یافت نشد
                </Col>
            </Row>
        </>
        :
        <>
            <Row style={{padding:"0px", margin:"20px 0px 0px 0px", position:"relative"}}>
                
                <Col className="d-flex justify-content-center align-items-center" style={{}}>
                    <Col md={3} style={{border:"1px solid #b0b0b0", padding:"10px", borderRadius:"10px", position:"relative"}}>
                        <img src={require("../lib/images/back.png")} alt='برگشت' onClick={()=>{onBackButtonClick()}} style={{width:"48px", height:"32px", position:"absolute", top:"5px", right:"10px", cursor:"pointer"}} />
                        <table style={{width:"100%", minWidth:"250px", marginLeft:"auto", marginRight:"auto"}}>
                            <tbody>
                                <tr>
                                    <td style={{width:"100%", textAlign:"center"}}>
                                        <img src={require('../lib/images/hana.webp')} style={{width:"64px"}} />
                                        {/* <span style={{fontSize:"4em", textAlign:"center"}} className="pi pi-user"></span> */}
                                    </td>
                                </tr>
                                <tr>
                                    <td style={{fontSize:"1.5em", textAlign:"center"}}>انتخاب درگاه پرداخت</td>
                                </tr>
                                <tr><td style={{borderBottom:"1px dashed #b0b0b0"}}>&nbsp;</td></tr>
                                <tr><td>&nbsp;</td></tr>
                                <tr>
                                    <td style={{position:"relative"}}>
                                        {
                                            ipgs.map((ipg, pInd)=>{
                                                return(
                                                    <>
                                                    <div onClick={()=>{onIpgSelected(pInd)}} style={{width:"calc(50% - 30px)", cursor:"pointer", minHeight:"100px", margin:"10px", borderRadius:"10px", float:"right", border:ipg.isChecked?"3px solid #3344ee":"1px dashed #b0b0b0", boxSizing:"border-box", padding:"10px", textAlign:"center"}}>
                                                        <img style={{width:"96px", height:"127px"}} src={require("../lib/ipg logo/" + ipg.logo)} alt="درگاه" />
                                                    </div>
                                                    </>
                                                )
                                            })
                                        }
                                        <div onClick={()=>{onIpgSelected(-1)}} style={{width:"calc(50% - 30px)", cursor:"pointer", minHeight:"100px", margin:"10px", borderRadius:"10px", float:"right", border:(selectedIndex == -1)?"3px solid #3344ee":"1px dashed #b0b0b0", boxSizing:"border-box", padding:"10px", textAlign:"center"}}>
                                            <img style={{width:"85px"}} src={require("../lib/ipg logo/wallet.png")} alt="کیف پول" />
                                            <br/>
                                            <label>کیف پول</label><br/>
                                            <label>مانده : {util.SeperatePrice(walletAmount)}</label><br/>

                                        </div>

                                    </td>
                                </tr>
                                <tr><td>&nbsp;</td></tr>
                                <tr>
                                    <td style={{textAlign:"center"}}>
                                        <label style={{backgroundColor:"#096409ff", color:"#FFF", padding:"10px 20px", fontSize:"14pt", borderRadius:"7px"}}>مبلغ پرداختی: {util.SeperatePrice(util.getIpgTransactionAmount())}</label>
                                    </td>
                                </tr>
                                <tr><td>&nbsp;</td></tr>
                                <tr>
                                    <td style={{fontSize:"1em", textAlign:"center", direction:"ltr"}}>
                                        <Button severity="success" loading={saving} onClick={()=>{onContinueButtonClick()}} style={{borderRadius:"5px"}}>&nbsp;&nbsp;تائید و پرداخت&nbsp;&nbsp;</Button>
                                        
                                    </td>
                                </tr>
                                <tr><td>&nbsp;</td></tr>

                            </tbody>
                        </table>
                    </Col>
                </Col>
            </Row>
            <ShowError visible={errorVisible} message={errorMessage} closeError={()=>{setErorVisible(false)}} />
        </>
    )
}